import { Avatar as AvatarCore, Badge as BadgeCore } from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

type ConversationItemProps = {
  isUnread: boolean;
};

export const ConversationItem = lib.styled.div<ConversationItemProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 45px;
  margin-bottom: 5px;
  padding-right: 9px;
  padding-left: 9px;
  padding-top: 3px;
  padding-bottom: 3px;
  border-radius: 13px;
  /* gap: 5px; */
  background-color: ${colors.white02};
  border: 1px solid ${(props: ConversationItemProps) =>
    props.isUnread ? colors.green02 : colors.lightGray17};
`;

export const ContactName = lib.styled.div`
  font-size: 13px;
  color: ${colors.black};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Details = lib.styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  cursor: pointer;
`;

export const Headerline = lib.styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 12px;

  .MuiChip-root {
    height: 18px;
    border-radius: 5px;
    font-size: 8px;
  }

  .MuiChip-root .MuiChip-avatar {
    display: flex;
    align-items: center;
    width: 12px;
    height: 12px;
  }
`;

export const Caption = lib.styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  max-width: 296px;
`;

export const RightSide = lib.styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 5px;
  max-width: 217px;
`;

export const Avatar = lib.styled(AvatarCore)`
  width: ${(props: any) => (props.size ? props.size : 35)}px;
  height: ${(props: any) => (props.size ? props.size : 35)}px;

  margin-right: 10px;
  border: 3px solid ${colors.white};
  background-color: ${colors.lightGray10};
  font-size: 12px !important;
  color: ${colors.black} !important;
  opacity: 0.5;
`;

export const MessagePreview = lib.styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  color: ${colors.lightGray02};
  padding-top: 3px;
`;

export const Counter = lib.styled(BadgeCore)`
  margin-top: 3px;
  
  .MuiBadge-badge {
    font-size: 0.6rem;
    height: 14px;
    min-width: 14px;
    padding: 0 4px;
  }

  .MuiBadge-colorPrimary {
    background-color: ${colors.green02} !important;
  }

`;

export const Badge = lib.styled(BadgeCore)`
  .MuiBadge-anchorOriginBottomRightCircular {
    right: 30%;
    bottom: 20%;

    svg {
      width: 15px;
      height: 15px;
    }
  }
`;
